import { actionTypes } from './actions';
import { initialState } from './initial';

export function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.ACTION_PROCESSING:
      return {
        ...state,
        actionProcessing: action.payload,
      };
    case actionTypes.GET_CUSTOM_REQUESTS:
      return {
        ...state,
        requests: action.payload,
      };
    case actionTypes.GET_CUSTOM_REQUESTS_NOTIFY:
      return {
        ...state,
        notifyRequests: action.payload,
      };
    case actionTypes.SAVE_PREV_CUSTOM_PROVIDER:
      return {
        ...state,
        previousProviders: {
          items: action.payload,
        },
      };
    case actionTypes.SAVE_PREV_CUSTOM_GAMES:
      return {
        ...state,
        previousGames: action.payload,
      };
    case actionTypes.REMOVE_CUSTOM_REQUEST:
      const id = action.payload;
      const newItems = [...state.requests.items];
      const match = newItems.findIndex(r => r.id === id);
      if (match !== -1) newItems.splice(match, 1);
      return {
        ...state,
        requests: { ...state.requests, items: newItems },
      };

    case actionTypes.CLEAR_SINGLE_CUSTOM_DATA:
      return {
        ...state,
        detailsData: {
          games: [],
          providers: [],
          socialMedia: [],
          notifications: '',
          meta: null,
        },
      };

    case actionTypes.GET_SINGLE_CUSTOM_REQUESTS:
      const data = action.payload;
      const games = data?.games || [];
      const providers = data?.providers || [];
      const socialMedia = data?.socialMedia || null;
      const notifications = data?.notifications || null;
      const meta = data.meta;
      const type = data.type;

      return {
        ...state,
        detailsData: {
          games,
          providers,
          socialMedia,
          notifications,
          meta,
          type,
        },
      };

    case actionTypes.GET_CUSTOM_PROVIDERS:
      return {
        ...state,
        providers: action.payload,
      };
    case actionTypes.GET_CUSTOM_GAMES:
      return {
        ...state,
        games: action.payload,
      };
    case actionTypes.GET_SOCIAL_MEDIA:
      return {
        ...state,
        socialMedia: action.payload,
      };
    default:
      return { ...state };
  }
}
